import { render, staticRenderFns } from "./CAvatar.vue?vue&type=template&id=2bc22701&"
import script from "./CAvatar.vue?vue&type=script&lang=ts&"
export * from "./CAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports